import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';
import FormFeedback from '../FormFeedback/FormFeedback';
import CancelIcon from '../../../../theme/assets/icons/cancel_confirm.svg';

import styles from './CancelSubscriptionForm.module.scss';
import { useTheme } from '../../../../../ThemeContext';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  error: string | null;
  submitting: boolean;
};

const CancelSubscriptionForm: React.FC<Props> = ({ onConfirm, onCancel, error, submitting }: Props) => {
  const { t } = useTranslation('account');
  const { universalStyles } = useTheme();
  return (
    <div>
      {error ? <FormFeedback variant="error">{error}</FormFeedback> : null}
      <span className={styles.icon}>
        <img src={CancelIcon} />
      </span>
      <h2 className={styles.title} style={universalStyles.primaryTextColor}>
        {t('user:payment.cancel_subscription')}
      </h2>

      <p className={styles.paragraph} style={universalStyles.primaryTextColor}>
        {t('user:payment.cancel_subscription_confirmation')}
      </p>

      <div className={styles.buttonBar}>
        <span>
          <Button onClick={onConfirm} size="exlarge" variant="signoutYes" label={t('yes')} disabled={submitting} className={styles.confirmButton} />
        </span>
        <span>
          <Button
            onClick={onCancel}
            color="primary"
            size="exlarge"
            variant="signoutNo"
            label={t('no')}
            className={styles.confirmButton}
            disabled={submitting}
          />
        </span>
      </div>
      {/* <Button
        className={styles.confirmButton}
        label={t('cancel_subscription.unsubscribe')}
        color="primary"
        variant="contained"
        onClick={onConfirm}
        fullWidth
        disabled={submitting}
        type="submit"
      /> */}
      {/* <Button label={t('cancel_subscription.no_thanks')} variant="transparent" onClick={onCancel} fullWidth /> */}
    </div>
  );
};

export default CancelSubscriptionForm;
